import { useEffect, useRef, useState } from 'react';

export const useAutoSlide = (length: number, delay: number = 3000) => {
  const [index, setIndex] = useState(0);
  const [isAuto, setIsAuto] = useState(true);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isAuto) return;

    timerRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % length);
    }, delay);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [length, delay, isAuto]);

  const handleManualChange = (manualIndex: number) => {
    setIsAuto(false);
    setIndex(manualIndex);
  };

  return [index, handleManualChange] as const;
};
